/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { PickSheetDtoBaseResponse } from '../models/pick-sheet-dto-base-response';
import { PickSheetItemStatus } from '../models/pick-sheet-item-status';
import { PickSheetListDtoListBaseResponse } from '../models/pick-sheet-list-dto-list-base-response';

@Injectable({
  providedIn: 'root',
})
export class PickSheetService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiPickSheetGetAllGet
   */
  static readonly ApiPickSheetGetAllGetPath = '/api/PickSheet/get-all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetGetAllGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGetAllGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<PickSheetListDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetGetAllGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PickSheetListDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetGetAllGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGetAllGet$Plain(params?: {
  }): Observable<PickSheetListDtoListBaseResponse> {

    return this.apiPickSheetGetAllGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PickSheetListDtoListBaseResponse>) => r.body as PickSheetListDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetGetAllGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGetAllGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<PickSheetListDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetGetAllGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PickSheetListDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetGetAllGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGetAllGet$Json(params?: {
  }): Observable<PickSheetListDtoListBaseResponse> {

    return this.apiPickSheetGetAllGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PickSheetListDtoListBaseResponse>) => r.body as PickSheetListDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiPickSheetGetGet
   */
  static readonly ApiPickSheetGetGetPath = '/api/PickSheet/get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetGetGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGetGet$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<PickSheetDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetGetGetPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PickSheetDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetGetGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGetGet$Plain(params?: {
    id?: number;
  }): Observable<PickSheetDtoBaseResponse> {

    return this.apiPickSheetGetGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PickSheetDtoBaseResponse>) => r.body as PickSheetDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetGetGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGetGet$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<PickSheetDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetGetGetPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PickSheetDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetGetGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGetGet$Json(params?: {
    id?: number;
  }): Observable<PickSheetDtoBaseResponse> {

    return this.apiPickSheetGetGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PickSheetDtoBaseResponse>) => r.body as PickSheetDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiPickSheetGeneratePost
   */
  static readonly ApiPickSheetGeneratePostPath = '/api/PickSheet/generate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetGeneratePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGeneratePost$Plain$Response(params?: {
    purchaseOrderId?: number;
  }): Observable<StrictHttpResponse<PickSheetDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetGeneratePostPath, 'post');
    if (params) {
      rb.query('purchaseOrderId', params.purchaseOrderId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PickSheetDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetGeneratePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGeneratePost$Plain(params?: {
    purchaseOrderId?: number;
  }): Observable<PickSheetDtoBaseResponse> {

    return this.apiPickSheetGeneratePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PickSheetDtoBaseResponse>) => r.body as PickSheetDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetGeneratePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGeneratePost$Json$Response(params?: {
    purchaseOrderId?: number;
  }): Observable<StrictHttpResponse<PickSheetDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetGeneratePostPath, 'post');
    if (params) {
      rb.query('purchaseOrderId', params.purchaseOrderId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PickSheetDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetGeneratePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetGeneratePost$Json(params?: {
    purchaseOrderId?: number;
  }): Observable<PickSheetDtoBaseResponse> {

    return this.apiPickSheetGeneratePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PickSheetDtoBaseResponse>) => r.body as PickSheetDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiPickSheetUpdateItemStatusPut
   */
  static readonly ApiPickSheetUpdateItemStatusPutPath = '/api/PickSheet/update-item-status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetUpdateItemStatusPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetUpdateItemStatusPut$Plain$Response(params?: {
    pickSheetItemId?: number;

    /**
     * 0 &#x3D; Pending
     * 
     * 1 &#x3D; Picked
     */
    status?: PickSheetItemStatus;
    userId?: number;
    userName?: string;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetUpdateItemStatusPutPath, 'put');
    if (params) {
      rb.query('pickSheetItemId', params.pickSheetItemId, {});
      rb.query('status', params.status, {});
      rb.query('userId', params.userId, {});
      rb.query('userName', params.userName, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetUpdateItemStatusPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetUpdateItemStatusPut$Plain(params?: {
    pickSheetItemId?: number;

    /**
     * 0 &#x3D; Pending
     * 
     * 1 &#x3D; Picked
     */
    status?: PickSheetItemStatus;
    userId?: number;
    userName?: string;
  }): Observable<BooleanBaseResponse> {

    return this.apiPickSheetUpdateItemStatusPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetUpdateItemStatusPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetUpdateItemStatusPut$Json$Response(params?: {
    pickSheetItemId?: number;

    /**
     * 0 &#x3D; Pending
     * 
     * 1 &#x3D; Picked
     */
    status?: PickSheetItemStatus;
    userId?: number;
    userName?: string;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetUpdateItemStatusPutPath, 'put');
    if (params) {
      rb.query('pickSheetItemId', params.pickSheetItemId, {});
      rb.query('status', params.status, {});
      rb.query('userId', params.userId, {});
      rb.query('userName', params.userName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetUpdateItemStatusPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetUpdateItemStatusPut$Json(params?: {
    pickSheetItemId?: number;

    /**
     * 0 &#x3D; Pending
     * 
     * 1 &#x3D; Picked
     */
    status?: PickSheetItemStatus;
    userId?: number;
    userName?: string;
  }): Observable<BooleanBaseResponse> {

    return this.apiPickSheetUpdateItemStatusPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiPickSheetAssignPickerPut
   */
  static readonly ApiPickSheetAssignPickerPutPath = '/api/PickSheet/assign-picker';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetAssignPickerPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetAssignPickerPut$Plain$Response(params?: {
    pickSheetId?: number;
    userId?: number;
    userName?: string;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetAssignPickerPutPath, 'put');
    if (params) {
      rb.query('pickSheetId', params.pickSheetId, {});
      rb.query('userId', params.userId, {});
      rb.query('userName', params.userName, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetAssignPickerPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetAssignPickerPut$Plain(params?: {
    pickSheetId?: number;
    userId?: number;
    userName?: string;
  }): Observable<BooleanBaseResponse> {

    return this.apiPickSheetAssignPickerPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetAssignPickerPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetAssignPickerPut$Json$Response(params?: {
    pickSheetId?: number;
    userId?: number;
    userName?: string;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetAssignPickerPutPath, 'put');
    if (params) {
      rb.query('pickSheetId', params.pickSheetId, {});
      rb.query('userId', params.userId, {});
      rb.query('userName', params.userName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetAssignPickerPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetAssignPickerPut$Json(params?: {
    pickSheetId?: number;
    userId?: number;
    userName?: string;
  }): Observable<BooleanBaseResponse> {

    return this.apiPickSheetAssignPickerPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiPickSheetCompletePut
   */
  static readonly ApiPickSheetCompletePutPath = '/api/PickSheet/complete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetCompletePut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetCompletePut$Plain$Response(params?: {
    pickSheetId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetCompletePutPath, 'put');
    if (params) {
      rb.query('pickSheetId', params.pickSheetId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetCompletePut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetCompletePut$Plain(params?: {
    pickSheetId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiPickSheetCompletePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetCompletePut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetCompletePut$Json$Response(params?: {
    pickSheetId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetCompletePutPath, 'put');
    if (params) {
      rb.query('pickSheetId', params.pickSheetId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetCompletePut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetCompletePut$Json(params?: {
    pickSheetId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiPickSheetCompletePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiPickSheetDeleteDelete
   */
  static readonly ApiPickSheetDeleteDeletePath = '/api/PickSheet/delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetDeleteDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetDeleteDelete$Plain$Response(params?: {
    pickSheetId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetDeleteDeletePath, 'delete');
    if (params) {
      rb.query('pickSheetId', params.pickSheetId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetDeleteDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetDeleteDelete$Plain(params?: {
    pickSheetId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiPickSheetDeleteDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPickSheetDeleteDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetDeleteDelete$Json$Response(params?: {
    pickSheetId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PickSheetService.ApiPickSheetDeleteDeletePath, 'delete');
    if (params) {
      rb.query('pickSheetId', params.pickSheetId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPickSheetDeleteDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPickSheetDeleteDelete$Json(params?: {
    pickSheetId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiPickSheetDeleteDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
